import React, { useEffect } from "react";
import Widget from "./Widget";
import { Grid } from "@mui/material";
import useAuth from "../../hooks/useAuth";
import { isFeatureAllowed, WidgetType } from "../../constants/Constants";
import { BANQUETBOOKING } from "../../constants/Permissions";


const Dashboard = () => {
  const { activeShopHash, authUser, isRoleAllowed } = useAuth();


  // const callHamesha = async () => {
  //   try {
  //     const response = await axios.get("http://localhost:7678/api/heartbeat");
  //     if (response) {
  //       console.log("callHamesha", response);
  //     }
  //     setTimeout(() => callHamesha(), 4000);
  //   } catch (error) {
  //     console.error("callHamesha", error);
  //     setTimeout(() => callHamesha(), 4000);
  //   }
  // }

  // useEffect(() => {
  //   callHamesha();
  // }, [])

  return (
    <div className="dashboard">
      <div className="dashbooard-container">
        <div className="widgets-container">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={4}>
              <Widget
                type={WidgetType.OWNER_DASHBOARD}
                isRoleAllowed={isRoleAllowed}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={4}>
              <Widget
                type={WidgetType.BOOK_ROOM}
                shopHash={activeShopHash?.id ?? ""}
                isRoleAllowed={isRoleAllowed}
              />
            </Grid>
            {
              isFeatureAllowed(authUser?.packages ?? "", BANQUETBOOKING) &&
              <Grid item xs={12} sm={12} md={12} lg={4}>
                <Widget
                  type={WidgetType.BOOK_BANQUET}
                  shopHash={activeShopHash?.id ?? ""}
                  isRoleAllowed={isRoleAllowed}
                />
              </Grid>
            }
            <Grid item xs={12} sm={12} md={12} lg={4}>
              <Widget
                type={WidgetType.SHOW_BOOKINGS}
                isRoleAllowed={isRoleAllowed}
              />
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
